import { collection, doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";

const GetAgentData = async (clientId, agentId) => {
  /**
   * input: null
   * output: agent details object
   * description: fetches agent details
   */
  try {
    let agentDoc = doc(db, "clients", clientId);
    agentDoc = collection(agentDoc, "agents");
    agentDoc = doc(agentDoc, agentId);
    const agent = (await getDoc(agentDoc)).data();
    return agent;
  } catch (error) {
    console.log(error);
  }
};

export default GetAgentData;
